var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    transform: "translate(-314.000000, -1896.000000)",
    fill: "#FEF854",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "innovative..",
    transform: "translate(0.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(108.000000, 711.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTN",
    transform: "translate(0.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.267227,26.1957048 L207.267227,24.8196007 C207.267227,24.2369259 207.738326,23.7658272 208.317902,23.7689266 L220.365011,23.7658272 C220.947686,23.7658272 221.418785,24.2369259 221.415686,24.8165013 L221.415686,36.8605119 C221.415686,37.4431866 220.944587,37.9142853 220.365011,37.911186 L218.988907,37.911186 C218.400034,37.911186 217.925836,37.4245906 217.938233,36.8357172 L218.114895,29.5491838 L209.20741,38.4566687 C208.795199,38.8688801 208.131942,38.8688801 207.71973,38.4566687 L206.727943,37.4648819 C206.315732,37.0526706 206.315732,36.3894132 206.727943,35.9772018 L215.635428,27.0697169 L208.342696,27.2463789 C207.750724,27.2618756 207.264128,26.7876775 207.267227,26.1957048 Z",
    id: "Path-6"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrow);
export default __webpack_public_path__ + "static/media/btn-arrow.97988facdbd218f227a046fdfdd7d014.svg";
export { ForwardRef as ReactComponent };